import uuid from 'node-uuid';

import { getSettlementDateForSubmissionDate } from '../calendar/selectors';
import { fetchCalendar } from '../calendar/actions';
import { goBackPage } from '../page/actions';
import { calendarTypes } from '../../config';

export const BACSDEBIT_ADD_PAYMENT = 'BACSDEBIT/ADD_PAYMENT';
export const BACSDEBIT_ADD_MULTIPLE_PAYMENTS = 'BACSDEBIT/ADD_MULTIPLE_PAYMENTS';
export const BACSDEBIT_UPDATE_TO_ACCOUNT = 'BACSDEBIT/UPDATE_TO_ACCOUNT';
export const BACSDEBIT_UPDATE_FROM_ACCOUNT = 'BACSDEBIT/UPDATE_FROM_ACCOUNT';
export const BACSDEBIT_UPDATE_SUBMISSION_DATE = 'BACSDEBIT/UPDATE_DATE';
export const BACSDEBIT_UPDATE_REFERENCE = 'BACSDEBIT/UPDATE_REFERENCE';
export const BACSDEBIT_REMOVE_PAYMENT = 'BACSDEBIT/REMOVE_PAYMENT';
export const BACSDEBIT_UPDATE_AMOUNT = 'BACSDEBIT/UPDATE_AMOUNT';
export const BACSDEBIT_COPY_REF_TO_ALL = 'BACSDEBIT/COPY_REF_TO_ALL';
export const BACSDEBIT_UPDATE_BACS_ID = 'BACSDEBIT/UPDATE_BACS_ID';
export const BACSDEBIT_UPDATE_PAYMENT_NAME = 'BACSDEBIT/UPDATE_PAYMENT_NAME';
export const BACSDEBIT_UPDATE_TRANSACTION_CODE = 'BACSDEBIT/UPDATE_TRANSACTION_CODE';
export const INITIALISE_BACS_DEBIT = 'INITIALISE_BACS_DEBIT';
export const BACSDEBIT_COPY_TRANSACTION_CODE_TO_ALL = 'BACSDEBIT/COPY_TRANSACTION_CODE_TO_ALL';
export const BACSDEBIT_SET_AUTHORISERS = 'BACSDEBIT/SET_AUTHORISERS';
export const BACSDEBIT_UPDATE_IMPORTED_PAYMENTS = 'BACSDEBIT/UPDATE_IMPORTED_PAYMENTS';

export const copyRefToAll = (paymentsToInternalCreditCards) => ({
	type: BACSDEBIT_COPY_REF_TO_ALL,
	paymentsToInternalCreditCards,
});

export const copyTransCodeToAll = () => ({
	type: BACSDEBIT_COPY_TRANSACTION_CODE_TO_ALL,
});

export const initialiseBacsDebit = (bacsDetails, payments = []) => ({
	type: INITIALISE_BACS_DEBIT,
	payments: payments.map((payment) => ({ ...payment, id: uuid.v1() })),
	bacsDetails: {
		...bacsDetails,
		context_id: bacsDetails.id,
		id: uuid.v1(),
	},
});

export const addPayment = (payment) => ({
	payment,
	type: BACSDEBIT_ADD_PAYMENT,
});

export const addMultiplePayments = (payments) => ({
	type: BACSDEBIT_ADD_MULTIPLE_PAYMENTS,
	payments,
});
export const updateToAccount = ({ accountId }) => ({
	type: BACSDEBIT_UPDATE_TO_ACCOUNT,
	accountId,
	meta: {
		allowedDuringApiCall: true,
	},
});

export const updateFromAccount = ({ id, accountId }) => ({
	type: BACSDEBIT_UPDATE_FROM_ACCOUNT,
	accountId,
	id,
});

export const updateSubmissionDate =
	({ submissionDate }) =>
	(dispatch, getState) => {
		const state = getState();
		const settlementDate = getSettlementDateForSubmissionDate(state, submissionDate);

		return dispatch({
			type: BACSDEBIT_UPDATE_SUBMISSION_DATE,
			submissionDate,
			settlementDate,
		});
	};

export const updateReference = ({ id, reference }) => ({
	type: BACSDEBIT_UPDATE_REFERENCE,
	id,
	reference,
	meta: {
		allowedDuringApiCall: true,
	},
});

export const removePayment = ({ id }) => ({
	type: BACSDEBIT_REMOVE_PAYMENT,
	id,
});

export const updateAmount = ({ id, amount }) => ({
	type: BACSDEBIT_UPDATE_AMOUNT,
	id,
	amount,
});

export const updateBacsId = ({ bacsId }) => ({
	type: BACSDEBIT_UPDATE_BACS_ID,
	bacsId,
	meta: {
		allowedDuringApiCall: true,
	},
});

export const updatePaymentName = ({ paymentName }) => ({
	type: BACSDEBIT_UPDATE_PAYMENT_NAME,
	paymentName,
});

export const updateTransactionCode = ({ id, transactionCode }) => ({
	type: BACSDEBIT_UPDATE_TRANSACTION_CODE,
	transactionCode,
	id,
});

export const goBackAfterDeadlineMissed = (submissionDate) => (dispatch) => {
	dispatch(updateSubmissionDate({ submissionDate }));
	return dispatch(fetchCalendar(calendarTypes.CALENDAR_TYPE_BACS)).then(() => dispatch(goBackPage()));
};

export const updateBacsDebitPayment =
	({ id, accountId, reference }) =>
	(dispatch) => {
		dispatch(updateFromAccount({ id, accountId }));
		return dispatch(updateReference({ id, reference }));
	};

export const setBacsDebitAuthorisers = (authorisers) => ({
	type: BACSDEBIT_SET_AUTHORISERS,
	authorisers,
});

export const updateBacsDebitImportedPayments = (importedPaymentsList) => ({
	type: BACSDEBIT_UPDATE_IMPORTED_PAYMENTS,
	payload: importedPaymentsList,
});
